import FingoMuiSelect, { selectButton } from '../../fingo/components/MuiSelect';
import { CURRENCY_PILL_SELECT_CLASS_NAME, SELECT_BUTTON_CLASS_NAME } from '../../constants/select';

const currencyPillSelect = ({ theme }) => ({
  width: '100%',
  height: '100%',
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    py: 0,
    px: 1.5,
    boxSizing: 'border-box',
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.text.highlight,
  },
});

const MuiSelect = {
  ...FingoMuiSelect,
  styleOverrides: {
    ...FingoMuiSelect.styleOverrides,
    root: ({ theme }) => ({
      ...FingoMuiSelect.styleOverrides.root({ theme }),
      [`&.${CURRENCY_PILL_SELECT_CLASS_NAME}`]: currencyPillSelect({ theme }),
      [`&.${SELECT_BUTTON_CLASS_NAME}`]: selectButton({ theme, mainColor: theme.palette.secondary.main }),
    }),
  },
};

export default MuiSelect;
